export default __webpack_public_path__ + "static/media/mission.ab614dce.svg";